const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/portals/$portalId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
type PortalSearchParams = {
  configure?: boolean;
};
export const Route = createFileRoute('/(app)/org/$org/intake/portals/$portalId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>): PortalSearchParams => {
    return {
      configure: search.configure as boolean | undefined
    };
  },
  staticData: {
    topNav: {
      title: i18n.t($ => $.intake.general.portals.label)
    }
  }
});